var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"color":_vm.chipColor,"label":"","small":""}},[_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"texte align-self-center pr-1",class:_vm.isAFixer ? 'texte-orange-fonce': 'secondary--text'},[_vm._v(" "+_vm._s(_vm.formattedLibelle)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }